import { createElement } from "/elements_functions/new_elements.js";
import { makeNewButton } from '/buttons_functions/custom_button_functions.js';

export function createNewCommentElement(submitCommentFunction, newCommentElementFunction) {

    if (!(newCommentElementFunction instanceof Function))
        return null;

    if (!(submitCommentFunction instanceof Function))
        return null;

    const newCommentElement = createElement('div', null, ['new-comment']);
    const textArea = createElement('textarea', null, ['new-comment-textarea']);
    
    const buttonsGroup = createElement('div', null, ['new-comment-buttons']);
    const cancelButton = createElement('button', null, ['new-comment-cancel-button']);
    const submitButton = createElement('button', null, ['new-comment-submit-button']);

    cancelButton.innerText = 'Cancel';
    submitButton.innerText = 'Post';

    submitButton.addEventListener('click', () => {
        const message = textArea.value;
        
        if(message.length===0)
            return null;

        submitCommentFunction(message, newCommentElement);

        textArea.value = '';
    });
    
    makeNewButton(cancelButton, 'gray', 'light-black', null, 'darken', null);
    makeNewButton(submitButton, 'light-black', 'white', null, 'lighten', null);

    buttonsGroup.append(cancelButton);
    buttonsGroup.append(submitButton);

    newCommentElement.append(textArea);
    newCommentElement.append(buttonsGroup);

    newCommentElement.textArea = textArea;
    newCommentElement.buttonsGroup = buttonsGroup;
    newCommentElement.cancelButton = cancelButton;
    newCommentElement.submitButton = submitButton;

    newCommentElementFunction(newCommentElement);

    return newCommentElement;

}